import { useContext } from 'react';

import { ProductVersionsContext } from '../context/product-versions-provider';

export const useProductVersions = () => {
  const context = useContext(ProductVersionsContext);

  if (!context) {
    throw new Error(
      'useProductVersions must be used within a ProductVersionsProvider',
    );
  }

  return context;
};
